/* eslint-disable @typescript-eslint/indent */
/* eslint-disable no-nested-ternary */
import React, { FC } from 'react'
import { Link } from 'react-router-dom'
import { BroadcastThumbnailInterface } from './broadcastCardTypes'
import BroadcastContentTypeSelector from './BroadcastContentTypeSelector'
import EmptyContent from './Empty'

import styles from './index.module.scss'
import { ThumbnailLink } from './ThumbnailLink'
import { useSelector } from 'react-redux'
import { channelSelector } from 'redux-store/channel/channel.selectors'
import { ConditionalRender } from 'components/ConditionalRender/ConditionalRender'
import { NativeThumbnailLink } from './NativeThumbnailLink'

interface Props {
  content: BroadcastThumbnailInterface | undefined
  shared: boolean
  showDetails: boolean
  size: 'xSmall' | 'small' | 'medium' | 'large' | 'xLarge' | 'keepRatio'
  disableLink: boolean
}
const BroadcastThumbnail: FC<Props> = ({
  content,
  shared,
  size,
  showDetails = true,
  disableLink = false
}) => {
  if (!content) return <EmptyContent size={size} />
  const channel = useSelector(channelSelector)

  const channelRootDomain = channel?.data?.is_root_channel
    ? channel?.data?.root_domain
    : channel?.data?.root_channel?.root_domain
  const linkPath = content.targetUrl
  const rootDomain =
    content.rootDomain && content.rootDomain !== channelRootDomain
      ? content.rootDomain
      : ''
  const showDomainLabel = rootDomain !== ''

  if (shared) {
    return (
      <div className={styles.SharedContainer}>
        <div className={styles.ChannelContainer}>
          <div className={styles.ChannelImageWrapper}>
            <img
              data-testid="channel-img"
              src={content.channelImg}
              alt={content.channelName}
            />
          </div>
          <Link to={content.channelUrl}>
            <div className={styles.ChannelName}>{content.channelName}</div>
          </Link>
        </div>
        <ConditionalRender mobileApp={false}>
          <ThumbnailLink link={linkPath} rootDomain={rootDomain}>
            <BroadcastContentTypeSelector
              content={content}
              size={size}
              showDetails={showDetails}
              showRootDomainLabel={showDomainLabel}
            />
          </ThumbnailLink>
        </ConditionalRender>
        <ConditionalRender web={false}>
          <NativeThumbnailLink link={linkPath} rootDomain={rootDomain}>
            <BroadcastContentTypeSelector
              content={content}
              size={size}
              showDetails={showDetails}
              showRootDomainLabel={showDomainLabel}
            />
          </NativeThumbnailLink>
        </ConditionalRender>
      </div>
    )
  }

  if (disableLink) {
    return (
      <BroadcastContentTypeSelector
        content={content}
        size={size}
        showDetails={showDetails}
        showRootDomainLabel={showDomainLabel}
      />
    )
  }

  return (
    <>
      <ConditionalRender mobileApp={false}>
        <ThumbnailLink link={linkPath} rootDomain={rootDomain}>
          <BroadcastContentTypeSelector
            content={content}
            size={size}
            showDetails={showDetails}
            showRootDomainLabel={showDomainLabel}
          />
        </ThumbnailLink>
      </ConditionalRender>
      <ConditionalRender web={false}>
        <NativeThumbnailLink link={linkPath} rootDomain={rootDomain}>
          <BroadcastContentTypeSelector
            content={content}
            size={size}
            showDetails={showDetails}
            showRootDomainLabel={showDomainLabel}
          />
        </NativeThumbnailLink>
      </ConditionalRender>
    </>
  )
}
export default BroadcastThumbnail
